import { IComponentOptions } from "angular";
import { ContractDetailsViewController } from "./controller";

export const vsComponentName = "contractInfoComponent";

export const contractInfoComponentOptions: IComponentOptions = {
  controller: ContractDetailsViewController,
  controllerAs: "contractInfoComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
